module.exports = __webpack_public_path__ + "img/album14_10.b6ecd757.jpg";